// extracted by mini-css-extract-plugin
export default {"error-btn":"style_error-btn__G466T"};